import { useMutation, useQueryClient } from "@tanstack/react-query"
import { fetcher } from "../fetcher"

type MutationFnParams = {
  emailAddress: string
  profileName: string
}

export function usePersonalDataMutation() {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, MutationFnParams>({
    mutationFn: async ({ profileName, emailAddress }) => {
      return fetcher(
        "/Verification/PersonalData",
        {
          method: "PUT",
          body: JSON.stringify({
            profileName,
            emailAddress,
          }),
        },
        {
          useAccessToken: true,
        }
      )
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ["personalData"] })
    },
  })
}
